















import Vue from 'vue';
import EditCardDropdown from '@/components/cards/EditCard/components/EditCardDropdown.vue';
import { updateObjectField } from '@/utils/crudActions';

export default Vue.extend({
  name: 'ObjectConclusion',
  components: { EditCardDropdown },
  props: {
    csrfToken: {
      type: String,
      required: true,
    },
    attrSlug: {
      type: String,
      required: true,
    },
    displayName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    presenterConfig: {
      type: Object,
      default: null,
    },
    currentValue: {
      type: String,
      default: null,
    },
    objectId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: this.currentValue,
    };
  },
  watch: {
    async value(newValue: string) {
      try {
        await updateObjectField({
          value: newValue,
          ignoreWarnings: false,
          comment: '',
          field: this.attrSlug,
          id: parseInt(this.objectId),
          type: this.objectType,
          csrf: this.csrfToken,
        });
        window.GGRC.zenModal.$emit('reloadPage');
      } catch (error) {
        window.GGRC.Notify(error);
      }
    },
  },
});
